import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { DOCUMENTS_SLICE_NAME, DocumentsState } from './models';

export const documentsSelector = (state: RootState): DocumentsState => state[DOCUMENTS_SLICE_NAME];

export const selectDocumentsIsLoading = createSelector(documentsSelector, (state: DocumentsState) => state.isLoading);
